/**
 * Losse gebeurtenissen uit een stroom halen zonder er tekens bij te verliezen.
 *
 * **HET GEBREK, gevonden op 24 augustus 2026 bij het nalezen van het
 * antwoordpad.** `ChatPage.jsx` deed dit:
 *
 *     const chunk = decoder.decode(value);
 *     const lines = chunk.split("\n").filter(l => l.startsWith("data: "));
 *
 * Daar zit geen buffer op. Het netwerk levert BYTES aan en niet regels, dus
 * een `data:`-regel kan over twee leveringen verdeeld raken. Wat er dan
 * gebeurt is het ergste van twee kwaden:
 *
 * - de eerste helft is geen geldige JSON en verdwijnt in de `catch`, die
 *   alleen naar de console schrijft
 * - de tweede helft begint niet met `data: ` en wordt weggefilterd
 *
 * **Er verdwijnt dus een stuk tekst uit het antwoord op het scherm, zonder
 * enige melding**, terwijl de database het volledige antwoord wel heeft.
 * Franks eis van 24 augustus, met zoveel woorden: tekens die stil verdwijnen
 * is erger dan traag.
 *
 * **EN EEN TWEEDE, KLEINERE, IN DEZELFDE TWEE REGELS.** `decoder.decode(value)`
 * zonder `{ stream: true }` vertelt de decoder dat dit de LAATSTE brok is.
 * Wordt een letter met een accent of een emoji over twee leveringen geknipt,
 * dan maakt hij er onherstelbaar een vraagteken van. Met `stream: true`
 * onthoudt hij de losse bytes tot de rest komt.
 *
 * **DIT WORDT WAARSCHIJNLIJKER NAARMATE HET ANTWOORD LANGER IS**, want er
 * zijn dan meer knippunten. En het is waarschijnlijker via de PWA dan op deze
 * machine: over Cloud Run en de tunnel worden gebeurtenissen samengevoegd en
 * opnieuw geknipt, terwijl ze op localhost meestal elk hun eigen pakketje
 * krijgen. Ik heb het niet zien gebeuren; het is een gat en geen waarneming.
 */

/** Een lezer die hele gebeurtenissen teruggeeft en halve vasthoudt.
 *
 *  Bewust een fabriek met een gesloten `rest` erin en geen klasse: zo is er
 *  geen manier om de buffer per ongeluk over te slaan, en is de toestand niet
 *  van buitenaf te bereiken.
 */
export function maakLezer() {
  let rest = "";

  return {
    /** Geef een stuk tekst en krijg de gebeurtenissen terug die AF zijn. */
    lees(stuk) {
      rest += stuk;
      const delen = rest.split("\n");
      // Het laatste deel is per definitie verdacht: er is geen regeleinde na
      // gezien, dus het kan een halve regel zijn. Dat blijft staan tot de
      // volgende levering. DIT IS DE HELE REPARATIE.
      rest = delen.pop();
      return delen
        .filter((regel) => regel.startsWith("data: "))
        .map((regel) => regel.slice(6));
    },

    /** Wat er nog vastgehouden wordt. Alleen om op te toetsen. */
    restant() {
      return rest;
    },

    /** De stroom is afgelopen: geef terug wat er nog ligt en dat af blijkt.
     *
     *  Een server die zijn laatste regel zonder afsluitend regeleinde stuurt,
     *  zou anders zijn slotgebeurtenis kwijt zijn. Dat is geen theorie: het
     *  hangt af van de webserver en niet van ons.
     */
    sluit() {
      const laatste = rest;
      rest = "";
      return laatste.startsWith("data: ") ? [laatste.slice(6)] : [];
    },
  };
}
